import React, { useEffect } from "react";
import { CssBaseline, Box } from "@mui/material";
import Header from "../components/registration/header";
import MetaDecorator from "../services/meta_decorator";
import NewLoginForm from "../components/login/newlogin";
import Footer from "../components/shared/footer";
import { bodyBg, footerContainer, fullHeight } from "../style2";


export default function Login() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box sx={{ ...bodyBg, ...fullHeight }}>
      <CssBaseline />
      <MetaDecorator
        title={"EnrichMyCare - Login"}
        description={"Login using your professional account"}
      />
      <Header />
      <NewLoginForm />
      <Box sx={{ marginTop: 8, paddingBottom: 8 }}>
        <table style={{ maxWidth: '80%', margin: "0 auto" }}>
          <tbody>
            <tr>
              <td style={{ width: "20%" }} align="center">
                <Box component="img" src='cyber-essential-seal.png' sx={{ width: 45, height: "auto" }} alt='' />
              </td>
              <td style={{ width: "20%" }} align="center">
                <Box component="img" alt="" src='ico-logo.png' sx={{ width: 70, height: "auto" }} />
              </td>
              <td style={{ width: "20%" }} align="center">
                <Box component="img" alt="" src='dcb-seal.png' sx={{ height: 50 }} />
              </td>
              <td style={{ width: "20%" }} align="center">
                <Box component="img" alt="" src='orcha.png' sx={{ height: 50 }} />
              </td>
              <td style={{ width: "20%" }} align="center">
                <Box component="img" alt="" src='oxford-university-hospitals.png' sx={{ height: 50 }} />
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
      <Box sx={{...footerContainer, position:"static" }}>
        <Footer />
      </Box>
    </Box>
  );
}
